/* ============================================
   NERAKCOS COURSE ENROLLMENT - JavaScript
   Storefront API cartCreate (tokenless first)
   Existing /cart is NEVER touched
   ============================================ */

(function() {
  'use strict';

  const NCE_CONFIG = {
    VARIANT_330: 'gid://shopify/ProductVariant/47801936314422',
    VARIANT_900: 'gid://shopify/ProductVariant/PLACEHOLDER_900',
    API_ENDPOINT: '/api/2026-07/graphql.json',
    STOREFRONT_TOKEN: null
  };

  const CART_MUTATION = `
    mutation cartCreate($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          id
          checkoutUrl
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  function getFormData(form) {
    return {
      fullName:   form.querySelector('#nce-full-name').value.trim(),
      email:      form.querySelector('#nce-email').value.trim(),
      phone:      form.querySelector('#nce-phone').value.trim(),
      country:    form.querySelector('#nce-country').value,
      experience: form.querySelector('#nce-experience').value,
      goals:      form.querySelector('#nce-goals').value.trim(),
      courseName: form.querySelector('#nce-course-name').value,
      variantId:  form.querySelector('#nce-variant-id').value,
      terms:      form.querySelector('#nce-terms').checked
    };
  }

  function validateForm(data, form) {
    let valid = true;
    const fields = [
      { key: 'fullName',  id: 'nce-full-name',  msg: 'Please enter your full name.' },
      { key: 'email',     id: 'nce-email',       msg: 'Please enter a valid email address.' },
      { key: 'phone',     id: 'nce-phone',       msg: 'Please enter your phone number.' },
      { key: 'country',   id: 'nce-country',     msg: 'Please select your country.' },
      { key: 'goals',     id: 'nce-goals',       msg: 'Please tell us your goals.' }
    ];

    fields.forEach(function(f) {
      const el = form.querySelector('#' + f.id);
      const err = form.querySelector('#' + f.id + '-error');
      if (!data[f.key]) {
        if (err) { err.style.display = 'block'; err.textContent = f.msg; }
        el.style.borderColor = '#c0392b';
        valid = false;
      } else {
        if (err) err.style.display = 'none';
        el.style.borderColor = '';
      }
    });

    const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (data.email && !emailReg.test(data.email)) {
      const el = form.querySelector('#nce-email');
      const err = form.querySelector('#nce-email-error');
      if (err) { err.style.display = 'block'; err.textContent = 'Please enter a valid email address.'; }
      el.style.borderColor = '#c0392b';
      valid = false;
    }

    if (!data.terms) {
      const err = form.querySelector('#nce-terms-error');
      if (err) { err.style.display = 'block'; err.textContent = 'Please agree to the Terms & Conditions.'; }
      valid = false;
    } else {
      const err = form.querySelector('#nce-terms-error');
      if (err) err.style.display = 'none';
    }

    return valid;
  }  const style = document.createElement('style');
  style.textContent = `

.nce-collage { display: grid; grid-template-columns: 1fr 1fr; grid-template-rows: 200px 200px; gap: 8px; margin-bottom: 24px; }
.nce-collage img { width: 100%; height: 100%; object-fit: cover; display: block; }
.nce-collage__quote { grid-column: 1 / -1; font-family: Georgia, serif; font-style: italic; font-size: 18px; color: #1a2818; text-align: center; padding: 10px 0; }

.nce-form-panel { background-color: #ffffff; padding: 40px; border: 1px solid #e0d8cc; }
.nce-form-panel__label { font-size: 10px; letter-spacing: 3px; text-transform: uppercase; color: #8B7355; font-family: sans-serif; margin-bottom: 8px; display: flex; align-items: center; gap: 10px; }
.nce-form-panel__label::before { content: ''; display: inline-block; width: 30px; height: 1px; background-color: #8B7355; }
.nce-form-panel__title { font-size: 26px; color: #1a2818; font-family: Georgia, serif; font-weight: normal; margin-bottom: 10px; }
.nce-form-panel__subtitle { font-size: 13px; color: #6b6055; line-height: 1.6; font-family: sans-serif; margin-bottom: 28px; }
.nce-form__group { margin-bottom: 18px; }
.nce-form__label { display: block; font-size: 12px; color: #1a2818; font-family: sans-serif; font-weight: 500; margin-bottom: 6px; letter-spacing: 0.5px; }
.nce-form__label span { color: #8B7355; }
.nce-form__input, .nce-form__select, .nce-form__textarea { width: 100%; padding: 12px 14px; border: 1px solid #d0c8bc; background-color: #faf8f4; font-size: 13px; color: #1a2818; font-family: sans-serif; outline: none; transition: border-color 0.2s ease; -webkit-appearance: none; appearance: none; border-radius: 0; }
.nce-form__input:focus, .nce-form__select:focus, .nce-form__textarea:focus { border-color: #8B7355; background-color: #ffffff; }
.nce-form__select { background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%238B7355' stroke-width='1.5' fill='none'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 14px center; padding-right: 36px; cursor: pointer; }
.nce-form__textarea { resize: vertical; min-height: 90px; }
.nce-form__checkbox-group { display: flex; align-items: flex-start; gap: 10px; margin-bottom: 24px; }
.nce-form__checkbox { width: 16px; height: 16px; margin-top: 2px; flex-shrink: 0; cursor: pointer; accent-color: #8B7355; }
.nce-form__checkbox-label { font-size: 12px; color: #6b6055; font-family: sans-serif; line-height: 1.5; }
.nce-form__checkbox-label a { color: #8B7355; text-decoration: underline; }
.nce-form__error { font-size: 11px; color: #c0392b; font-family: sans-serif; margin-top: 4px; display: none; }
.nce-form__submit { width: 100%; background-color: #1a2818; color: #ffffff; padding: 18px 24px; font-size: 12px; letter-spacing: 2.5px; text-transform: uppercase; font-family: sans-serif; border: none; cursor: pointer; transition: background-color 0.3s ease; display: flex; align-items: center; justify-content: center; gap: 10px; }
.nce-form__submit:hover:not(:disabled) { background-color: #2d4428; }
.nce-form__submit:disabled { opacity: 0.7; cursor: not-allowed; }
.nce-form__submit-arrow { font-size: 16px; transition: transform 0.2s ease; }
.nce-form__submit:hover .nce-form__submit-arrow { transform: translateX(4px); }
.nce-form__message { padding: 14px 16px; font-size: 13px; font-family: sans-serif; margin-bottom: 16px; display: none; line-height: 1.5; }
.nce-form__message--error { background-color: #fdf0f0; border: 1px solid #e0b0b0; color: #8b2020; }
.nce-form__message--success { background-color: #f0f5f0; border: 1px solid #a0c0a0; color: #1a4020; }

.nce-trust { background-color: #f5f0e8; border-top: 1px solid #e0d8cc; padding: 40px 60px; }
.nce-trust__grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px; max-width: 800px; margin: 0 auto; text-align: center; }
.nce-trust__icon { font-size: 24px; margin-bottom: 10px; display: block; }
.nce-trust__title { font-size: 13px; color: #1a2818; font-family: sans-serif; font-weight: 600; margin-bottom: 4px; }
.nce-trust__desc { font-size: 12px; color: #6b6055; font-family: sans-serif; }

.nce-spinner { width: 16px; height: 16px; border: 2px solid rgba(255,255,255,0.3); border-top-color: #ffffff; border-radius: 50%; animation: nce-spin 0.8s linear infinite; display: none; }
@keyframes nce-spin { to { transform: rotate(360deg); } }

@media (max-width: 900px) {
  .nce-hero { grid-template-columns: 1fr; min-height: auto; }
  .nce-hero__image { height: 300px; }
  .nce-hero__content { padding: 50px 30px; }
  .nce-benefits__grid { grid-template-columns: repeat(2, 1fr); }
  .nce-benefits { padding: 40px 30px; }
  .nce-main { padding: 50px 30px; }
  .nce-main__grid { grid-template-columns: 1fr; gap: 40px; }
  .nce-trust { padding: 40px 30px; }
}

@media (max-width: 600px) {
  .nce-hero__title { font-size: 30px; }
  .nce-hero__price { font-size: 28px; }
  .nce-benefits__grid { grid-template-columns: 1fr 1fr; }
  .nce-collage { grid-template-rows: 150px 150px; }
  .nce-form-panel { padding: 28px 20px; }
  .nce-trust__grid { grid-template-columns: 1fr; gap: 24px; }
  .nce-hero__badge { display: none; }
}
    `;
  document.head.appendChild(style);
  function showMessage(form, type, text) {
    const msg = form.querySelector('.nce-form__message');
    if (!msg) return;
    msg.className = 'nce-form__message nce-form__message--' + type;
    msg.textContent = text;
    msg.style.display = 'block';
    msg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function setLoading(btn, loading) {
    const arrow = btn.querySelector('.nce-form__submit-arrow');
    const spinner = btn.querySelector('.nce-spinner');
    btn.disabled = loading;
    if (loading) {
      btn.querySelector('.nce-btn-text').textContent = 'Processing...';
      if (arrow) arrow.style.display = 'none';
      if (spinner) spinner.style.display = 'inline-block';
    } else {
      btn.querySelector('.nce-btn-text').textContent = btn.getAttribute('data-label') || 'ENROLL NOW';
      if (arrow) arrow.style.display = 'inline';
      if (spinner) spinner.style.display = 'none';
    }
  }

  async function createCart(data) {
    const headers = { 'Content-Type': 'application/json' };
    if (NCE_CONFIG.STOREFRONT_TOKEN) {
      headers['X-Shopify-Storefront-Access-Token'] = NCE_CONFIG.STOREFRONT_TOKEN;
    }
    const body = JSON.stringify({
      query: CART_MUTATION,
      variables: {
        input: {
          lines: [{ merchandiseId: data.variantId, quantity: 1 }],
          attributes: [
            { key: 'Full Name',  value: data.fullName },
            { key: 'Email',      value: data.email },
            { key: 'Phone',      value: data.phone },
            { key: 'Country',    value: data.country },
            { key: 'Experience', value: data.experience || 'Not specified' },
            { key: 'Goals',      value: data.goals },
            { key: 'Course',     value: data.courseName }
          ],
          buyerIdentity: { email: data.email, phone: data.phone }
        }
      }
    });
    const response = await fetch(NCE_CONFIG.API_ENDPOINT, { method: 'POST', headers, body });
    if (response.status === 401) throw new Error('AUTH_REQUIRED');
    if (!response.ok) throw new Error('API_ERROR');
    const json = await response.json();
    if (json.errors && json.errors.length > 0) throw new Error(json.errors[0].message);
    const cart = json.data && json.data.cartCreate && json.data.cartCreate.cart;
    const userErrors = json.data && json.data.cartCreate && json.data.cartCreate.userErrors;
    if (userErrors && userErrors.length > 0) throw new Error(userErrors[0].message);
    if (!cart || !cart.checkoutUrl) throw new Error('No checkout URL received.');
    return cart.checkoutUrl;
  }
async function handleSubmit(e) {
  e.preventDefault();
  const form = e.target;
  const variantId = form.querySelector('#nce-variant-id').value;
  if (variantId === 'gid://shopify/ProductVariant/47801936314422') {
    window.location.href = '/pages/course-payment-330';
  } else {
    window.location.href = '/pages/course-payment-900';
  }
}
  function initEnrollmentForms() {
    const forms = document.querySelectorAll('.nce-enrollment-form');
    forms.forEach(function(form) {
      form.addEventListener('submit', handleSubmit);
      const btn = form.querySelector('.nce-form__submit');
      if (btn) {
        const textEl = btn.querySelector('.nce-btn-text');
        if (textEl) btn.setAttribute('data-label', textEl.textContent);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEnrollmentForms);
  } else {
    initEnrollmentForms();
  }

})();
